export default {
    API_URL: 'https://qa-scooter.education-services.ru'
};